
import React, { Fragment } from "react";

import SweetAlert from 'sweetalert2';
import { toast } from "react-toastify";

import { systemEmail } from 'Services';
import TableRowDelete from 'CommonElements/Table/TableRowDelete';


const DeleteSystemEmail = ({ data={}, loadData }) => {


  const deleteEmail = () => {
    SweetAlert.fire({
        title: 'Are you sure?',
        text: 'Once deleted, you will not be able to recover this record!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'cancel',
        reverseButtons: true,
    }).then((result) => {
        if (result.value) {
            systemEmail.deleteEmail(data.id).then(res => {
                toast.success('Email deleted, successfully');
                loadData();
            }).catch(err => {
                toast.error('Failed to delete Email');

            })
        }
    });
};
  return (
    <Fragment>
        <TableRowDelete onClick={deleteEmail} />

    </Fragment>
  );
};

export default DeleteSystemEmail;
